
// useDownloadAttachment.ts
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useState } from 'react'
import { useDownloadZip } from '../s3/useDownloadZip'

interface Attachment {
  url: string
  name?: string
}
interface SelectedFile {
  id: string
  name: string
  mimeType: string
  url: string
  embedUrl?: string
  iconLink?: string
  thumbnailLink?: string
  rawFile?: File // Optional, helpful for backend upload
}
interface _Note {
  note_id: string
  contents: string
  tagIds?: string[]
  taggedUsers: object[]
  owner?: string[] // user IDs of owners
  createdAt: string
  iconLink: string
  thumbnailLink: string
  embedUrl: string
  context: string
  attachments?: SelectedFile[]
}

const _extractKeyFromS3Url = (url: string): string | null => {
  const match = url.match(/\.amazonaws\.com\/(.+)$/)
  return match?.[1] || null
}

export const useDownloadAttachment = () => {
  const [isDownloading, setIsDownloading] = useState(false)
  const { mutate: downloadZip, isPending: isZipDownloading } = useDownloadZip()
  const getPresignedUrl = async (key: string): Promise<string> => {
    const response = await axios.get<{ url: string }>(`${baseUrl}/aws/s3/download-file`, {
      params: { key },
    })
    return response.data.url
  }

  const triggerNativeDownload = (url: string, filename: string) => {
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const downloadAttachment = async (s3Url: string, name?: string) => {
    setIsDownloading(true)
    try {
      const key = s3Url.split('.amazonaws.com/')[1]
      if (!key) throw new Error('Invalid S3 URL')
      const presignedUrl = await getPresignedUrl(key)
      triggerNativeDownload(presignedUrl, name || key.split('/').pop() || 'downloaded_file')
    } catch (err) {
      console.error('❌ Error downloading attachment:', err)
    } finally {
      setIsDownloading(false)
    }
  }

  const downloadAllAttachments = (attachments: Attachment[], zipName: string) => {
    console.log('attachments', attachments)
    const keys = attachments.map(att => att.url.split('.amazonaws.com/')[1]).filter(Boolean)
    console.log('keys', keys)
    if (!keys.length) return

    downloadZip(
      { keys, zipName },
      {
        onSuccess: url => {
          const a = document.createElement('a')
          a.href = url
          a.download = zipName
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        },
        onError: err => {
          console.error('❌ Failed to generate ZIP:', err)
        },
      }
    )
  }

  return {
    isDownloading: isDownloading || isZipDownloading,
    downloadAttachment,
    downloadAllAttachments,
  }
}
